import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById("root"));

// axios.defaults.xsrfCookieName = "y7R1bnNhpYJjYaUo3OtyyHAJ02peAmn5";
// axios.defaults.withCredentials = true;
// axios.defaults.xsrfHeaderName='';
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
